'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002413 from "./presto.-Agent-View$$anon$13.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024 from "./presto.-Agent-View$-Upload-File-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$12() {
  this.aw1 = null;
  this.avT = null;
  this.avU = false;
  this.aw2 = null;
  this.aw3 = false;
  this.aw6 = null;
  this.avZ = null;
  this.aw0 = false;
  this.avV = null;
  this.avW = false;
  this.avX = null;
  this.avY = false;
  this.aw4 = false;
  this.aw5 = false;
  this.aw1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aw6 = "UploadFileRequest";
}
export { $c_Lpresto_AgentView$$anon$12 as $c_Lpresto_AgentView$$anon$12 };
$p = $c_Lpresto_AgentView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$12;
/** @constructor */
function $h_Lpresto_AgentView$$anon$12() {
}
export { $h_Lpresto_AgentView$$anon$12 as $h_Lpresto_AgentView$$anon$12 };
$h_Lpresto_AgentView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aw1;
});
$p.L = (function() {
  if ((!this.avU)) {
    this.avT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avU = true;
  }
  return this.avT;
});
$p.O = (function() {
  if ((!this.aw3)) {
    this.aw2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aw3 = true;
  }
  return this.aw2;
});
$p.E = (function() {
  return this.aw6;
});
$p.t = (function() {
  if ((!this.aw0)) {
    this.avZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("text", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aw0 = true;
  }
  return this.avZ;
});
$p.M = (function() {
  if ((!this.avW)) {
    this.avV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.avW = true;
  }
  return this.avV;
});
$p.Q = (function() {
  if ((!this.avY)) {
    this.avX = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002413.$c_Lpresto_AgentView$$anon$13();
    this.avY = true;
  }
  return this.avX;
});
$p.w = (function() {
  if ((!this.aw5)) {
    this.aw4 = false;
    this.aw5 = true;
  }
  return this.aw4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee84) => ((p) => \u03b4scrutinee84.cFS(p)))($j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024.$m_Lpresto_AgentView$UploadFileRequest$())));
});
var $d_Lpresto_AgentView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$12, "presto.AgentView$$anon$12", ({
  DA: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$12 as $d_Lpresto_AgentView$$anon$12 };
//# sourceMappingURL=presto.-Agent-View$$anon$12.js.map
